import { apiClient } from '@shared/api/client'
import type { LoginResponse, MemberResponse, OAuth2LoginRequest } from '../model/types'

export const authApi = {
  loginOAuth: async (
    provider: 'kakao' | 'google',
    req: OAuth2LoginRequest,
  ): Promise<LoginResponse> => {
    const { data } = await apiClient.post<LoginResponse>(`/v1/auth/login/${provider}`, req)
    return data
  },

  getMe: async (): Promise<MemberResponse> => {
    const { data } = await apiClient.get<MemberResponse>('/v1/auth/me')
    return data
  },
}
